// Invalid area codes for personal phone numbers:
// 0 and 1 = emergency and other special numbers
// 58 and 59 = machine-to-machine communication
// 8 = premium rate, voting, etc.

import { norwegianCountryCodeString } from "./norwegianCountryCode";

export const norwegianAreaCodeInvalid = new RegExp(`^(${norwegianCountryCodeString})(0|1|58|59|8)`);
